import {Component, computed, input, OnInit, signal} from '@angular/core';
import {AuditLogEventDetails, FullTaDetails} from '../../../api';
import {TaSubmissionDatasource} from '../../../datasources/ta-submission.datasource';
import {TableModule} from 'primeng/table';
import {DatePipe, NgClass} from '@angular/common';
import {Button} from 'primeng/button';
import {
  toCommentAuditText,
  toEventMetaTypesText,
  toEventMetaValueText,
  toEventTypeDisplayText,
  toEventTypesText
} from '../../../util/app.types';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TaSpinnerComponent} from '../taspinner.component/taspinner.component';

@Component({
  selector: 'ta-audit-log',
  imports: [
    TableModule,
    DatePipe,
    NgClass,
    Button,
    TaSpinnerComponent
  ],
  templateUrl: './ta-audit-log.component.html',
  styleUrl: './ta-audit-log.component.scss'
})
export class TaAuditLogComponent implements OnInit {
  taSubmission = input<FullTaDetails | undefined>(undefined);
  eventLogs: AuditLogEventDetails[] = [];
  /** The log is fetched as the dialog opens, so it starts out loading rather than empty. */
  protected loading = signal(false);
  selectedEvent = signal<AuditLogEventDetails | undefined>(undefined);
  selectedEventMetadata = computed(() => {
    if (this.selectedEvent()?.metadata) {
      return Object.entries(this.selectedEvent()!.metadata!);
    }
    return [];
  })

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private taSubmissionDatasource: TaSubmissionDatasource,
  ) {}

  ngOnInit() {
    if (this.taSubmission()?.id) {
      this.loading.set(true);
      this.taSubmissionDatasource.loadSubmissionAuditLog(this.taSubmission()!.id!).subscribe({
        next: (response) => {
          if (response.success && !!response.data) {
            this.eventLogs = response.data;
          }
          this.loading.set(false);
        },
        error: (error) => {
          console.error('getAuditLog error:', error);
          this.loading.set(false);
        },
      });
    }
  }

  viewExtraDetails(event: AuditLogEventDetails): void {
    if (event === this.selectedEvent()) {
      this.selectedEvent.set(undefined);
    } else {
      this.selectedEvent.set(event);
    }
  }

  closeDialog(data: any): void {
    this.ref.close(data);
  }

  /** The event's comment as plain text - a workflow tag as `Label: `, mentions flattened to `@Name`. */
  protected commentText(event: AuditLogEventDetails): string {
    const comment = event.metadata?.['comment'];
    return comment == null ? 'None' : toCommentAuditText(comment);
  }

  protected readonly toEventTypesText = toEventTypesText;
  protected readonly toEventTypeDisplayText = toEventTypeDisplayText;
  protected readonly toEventMetaTypesText = toEventMetaTypesText;
  protected readonly toEventMetaValueText = toEventMetaValueText;
}
